










import { defineComponent } from '@vue/composition-api'
export default defineComponent({
  props: {
    title: { type: String, default: 'TITLE', required: true },
    careers: {
      type: Array,
      required: true
    }
  }
})
